import { combineReducers } from 'redux';
import settings from './settings.reducer';
import storage from './storage.reducer';
import developer from './developer.reducer';
import commissionedMachines from './commissionedMachines.reducer';
import llmProviders from './llmProviders.reducer';

const reducer = combineReducers({
	settings,
	storage,
	developer,
	commissionedMachines,
	llmProviders
});

export default reducer;
